export default __webpack_public_path__ + "static/img/footer-bg.16e9908.png";